import React from "react";
import Preloader from "../../helper/Preloader";
 import Breadcrumb from "../../components/Breadcrumb";
  import ScrollToTop from "react-scroll-to-top";
import HeaderOneCustomer from "../../componentsAmazon/HeaderOneCustomer";
import ShopSectionAmazon from "../../componentsAmazon/ShopSectionAmazon";
import FooterOne from "../../components/FooterOne";

const ShopPageAmazon = () => {
 
    
  return (
    <>

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />
 {/* HeaderOneCustomer */}
 <HeaderOneCustomer />

      {/* Conditionally Render Components */}

        <ShopSectionAmazon />
   
  

      {/* FooterOne */}
      <FooterOne />


    </>
  );
};

export default ShopPageAmazon;
